var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  stroke: "#6E3037",
  strokeWidth: 3,
  d: "M31.667 12.5a4.167 4.167 0 1 0 0-8.333 4.167 4.167 0 0 0 0 8.333Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M35.416 16.667v8.75a10 10 0 0 1-10 10H14.583a10 10 0 0 1-10-10V14.584a10 10 0 0 1 10-10h8.75M13.793 26.727v-7.313m6.383 7.313V14.615m6.03 12.112v-9.183"
})));
export default SvgDashboard;